// extracted by mini-css-extract-plugin
export default {"warning":"style_warning__SnlLu"};